import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
//import Tasks from "components/Tasks/Tasks.js";
import Roles from "components/Roles/Roles.js";
import Permissions from "components/Permissions/Permissions.js";
import Menus from "components/Menus/Menus.js";
import PhanQuyenMenu from "components/PhanQuyenMenu/PhanQuyenMenu.js";
import RolePermission from "components/RolePermission/RolePermission.js";
import PhanQuyenDashboard from "components/PhanQuyenMenu/PhanQuyenDashboard.js";

export default function RolesMenuPermission() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Roles",
            tabContent: <Roles />,
          },
          {
            tabName: "Permision",
            tabContent: <Permissions />,
          },
          {
            tabName: "Menu",
            tabContent: <Menus />,
          },
          {
            tabName: "Role Menu",
            tabContent: <PhanQuyenMenu />,
          },
          {
            tabName: "Role Permission",
            tabContent: <RolePermission />,
          },
          {
            tabName: "Phân quyền Dashboard",
            tabContent: <PhanQuyenDashboard />,
          },
        ]}
      />
    </div>
  );
}
